import { render, staticRenderFns } from "./CourseNewRefundClaimPage.vue?vue&type=template&id=39f6cb0f&"
import script from "./CourseNewRefundClaimPage.vue?vue&type=script&lang=ts&"
export * from "./CourseNewRefundClaimPage.vue?vue&type=script&lang=ts&"
import style0 from "./CourseNewRefundClaimPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VDivider,VIcon,VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
